import React from 'react';

const KATEGORIER = [
  { id: 'hagearbeid', name: 'Hagearbeid', icon: 'yard' },
  { id: 'flyttehjelp', name: 'Flyttehjelp', icon: 'local_shipping' },
  { id: 'rengjoring', name: 'Rengjøring', icon: 'cleaning_services' },
  { id: 'smajobber', name: 'Småjobber', icon: 'handyman' },
  { id: 'dyrepass', name: 'Dyrepass', icon: 'pets' },
  { id: 'transport', name: 'Transport', icon: 'directions_car' },
  { id: 'it-hjelp', name: 'IT-hjelp', icon: 'computer' },
  { id: 'annet', name: 'Annet', icon: 'more_horiz' }
];

const CategorySelector = ({ selected, onSelect, showAll = false }) => {
  return (
    <div className="w-full">
      <h3 className="font-heading font-semibold text-[#0A1929] mb-3 flex items-center gap-2">
        <span className="material-symbols-outlined text-[#1E3A5F]">category</span>
        Velg kategori
      </h3>
      <div className="flex overflow-x-auto pb-2 gap-3 scrollbar-hide md:flex-wrap">
        {showAll && (
          <button
            onClick={() => onSelect(null)}
            className={`flex-shrink-0 flex flex-col items-center gap-2 p-4 rounded-xl transition-all min-w-[90px] ${
              selected === null
                ? 'bg-[#0A1929] text-white shadow-lg'
                : 'bg-white text-[#0A1929] border border-slate-200 hover:border-[#1E3A5F] hover:shadow-md'
            }`}
          >
            <span className="material-symbols-outlined text-2xl">apps</span>
            <span className="text-xs font-medium">Alle</span>
          </button>
        )}
        {KATEGORIER.map((kategori) => (
          <button
            key={kategori.id}
            onClick={() => onSelect(kategori.id)}
            className={`flex-shrink-0 flex flex-col items-center gap-2 p-4 rounded-xl transition-all min-w-[90px] ${
              selected === kategori.id
                ? 'bg-[#0A1929] text-white shadow-lg'
                : 'bg-white text-[#0A1929] border border-slate-200 hover:border-[#1E3A5F] hover:shadow-md'
            }`}
          >
            <span className="material-symbols-outlined text-2xl">{kategori.icon}</span>
            <span className="text-xs font-medium text-center">{kategori.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export { KATEGORIER };
export default CategorySelector;
